import styled from 'styled-components';

import { breakpoint } from '../../Grid';
import { upTo } from 'js/services/MediaQuery';

export default styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-areas: 'prev current next';
  user-select: none;

  ${upTo(breakpoint)`
    justify-self: start;
  `}
`;
